/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../../../components/ui-elements/table/StyledTableRow';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import { BsClipboard, BsFillPencilFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import DialogContainer from '../../../../../../../../components/shared/Dialog/DialogContainer';
import { FaHistory } from 'react-icons/fa';
import OrgAppAuthProviderEdit from './OrgAppAuthProviderEdit';
import OrgAppAuthProviderHistory from './OrgAppAuthProviderHistory';
import CopyToClipboard from 'react-copy-to-clipboard';

const OrgAppsAuthProvidersList = () => {
    const [selectedOrgAppsAuthProviders, setSelectedOrgAppsAuthProviders] = useState({});
    const [openEditOrgAppsAuthProviders, setOpenEditOrgAppsAuthProviders] = useState(false);
    const [openHistoryOrgAppsAuthProviders, setOpenHistoryOrgAppsAuthProviders] = useState(false);
    const orgAppAuthProviders = useSelector(state => state.orgAppAuthProvider.orgAppAuthProviders)

    const handleCloseDialog = () => {
        setOpenEditOrgAppsAuthProviders(false);
        setOpenHistoryOrgAppsAuthProviders(false);
    }

    return (
        <><TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell label="Organization Name" />
                        <StyledTableCell label="AuthProvider Name" />
                        <StyledTableCell label="Application Name" />
                        <StyledTableCell label="Assertion Custom URL" />

                        <StyledTableCell label="Details" />
                        <StyledTableCell label=" " />

                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {orgAppAuthProviders?.Records?.length > 0 && orgAppAuthProviders.Records.map((row) => (
                        <StyledTableRow key={row.organizationID}>
                            <StyledTableCell label={row.organizationName} />
                            <StyledTableCell label={row.authProviderName} />
                            <StyledTableCell label={row.applicationName} />
                            <StyledTableCell align="left">
                                {row?.assertionConsumerServiceURL && (
                                    <Tooltip title={row.assertionConsumerServiceURL} placement="top-start" arrow>
                                        <div style={{ textAlign: 'left', textTransform: 'none' }}>
                                            <CopyToClipboard text={row.assertionConsumerServiceURL}>
                                                <Button
                                                    variant="text"
                                                    startIcon={<BsClipboard />}
                                                    style={{
                                                        textTransform: 'none',
                                                        justifyContent: 'flex-start',
                                                        padding: 0,
                                                        minWidth: 0
                                                    }}                                                >
                                                    {row.assertionConsumerServiceURL.substring(0, 35)}...
                                                </Button>
                                            </CopyToClipboard>
                                        </div>
                                    </Tooltip>
                                )}
                            </StyledTableCell>

                            <StyledTableCell   >
                                {row.organizationApplicationAuthProviderDetails.length > 0 ?
                                    <Typography style={{ fontWeight: 'bold' }} color={row.organizationApplicationAuthProviderDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                        {row.organizationApplicationAuthProviderDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                    </Typography> : "N/A"}
                            </StyledTableCell>

                            <StyledTableCell align="right"  >
                                <Tooltip title={row.organizationName + " " + row.authProviderName + "  Edit"} placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAppsAuthProviders(row); setOpenEditOrgAppsAuthProviders(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={row.organizationName + " " + row.authProviderName + "  History"} placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAppsAuthProviders(row); setOpenHistoryOrgAppsAuthProviders(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </Tooltip>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>


            <DialogContainer
                open={openEditOrgAppsAuthProviders}
                handleClose={handleCloseDialog}
            >
                <OrgAppAuthProviderEdit
                    selectedOrgAppAuthProvider={selectedOrgAppsAuthProviders}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryOrgAppsAuthProviders}
                handleClose={handleCloseDialog}
            >
                <OrgAppAuthProviderHistory
                    selectedOrgAppAuthProvider={selectedOrgAppsAuthProviders}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default OrgAppsAuthProvidersList;
